import axios from './axios';

export const ordersAPI = {
  create: async (orderData) => {
    const response = await axios.post('/orders', orderData);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await axios.get('/orders', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/orders/${id}`);
    return response.data;
  },

  cancel: async (id) => {
    const response = await axios.put(`/orders/${id}/cancel`);
    return response.data;
  },
};